<template>

  <t-page>

    <b-modal
        id="report-config-modal"
        ref="reportConfigModal"
        size="xl"
        scrollable
        hide-footer
        :title="reportConfigTitle"
        dialog-class="report-config-modal"
        @hidden="modalConfigType = null"
    >

      <div class="report-config-modal__body p-3">

        <!-- Relatórios de Apontamentos -->
        <ReportPhotoChecklistEstate
            v-if="modalConfigType === 'occurrence_estate' && relationAccessSubValidation('sub-checklist-report-photos-estate-inspection')"
            :enterprise-id="enterpriseId"
            :checklist-id="checklistId"
        />

        <ReportPhotoChecklistOccurrence
            v-if="modalConfigType === 'occurrence_inspection' &&
             relationAccessSubValidation('sub-checklist-report-photos-by-inspection-finish')"
            :enterprise-id="enterpriseId"
            :checklist-id="checklistId"
        />

        <ReportPhotoOccurrenceByEnterprise
            v-if="modalConfigType === 'occurrence_enterprise' &&
             relationAccessSubValidation('sub-checklist-report-photos-occurrence-by-enterprise')"
            :enterprise-id="enterpriseId"
            :checklist-id="checklistId"
        />

        <ReportChecklistManagement
            v-else-if="modalConfigType === 'management_by_enterprise'"
            :enterprise-id="enterpriseId"
            :checklist-id="checklistId"
        />

        <ReportOccurrenceQuality
            v-else-if="modalConfigType === 'occurrence_kpi'"
            :enterprise-id="enterpriseId"
            :checklist-id="checklistId"
        />
        <!---->

        <ReportPhotoChecklistEvidence
            v-if="modalConfigType === 'evidence_inspection' &&
            relationAccessSubValidation('sub-checklist-report-photos-evidence')"
            :enterprise-id="enterpriseId"
            :checklist-id="checklistId"

        />

        <ReportPhotoEnterpriseEvidence
            v-if="modalConfigType === 'evidence_enterprise' &&
            relationAccessSubValidation('sub-checklist-report-photos-enterprise')"
            :enterprise-id="enterpriseId"
            :type-checklist-id="typeChecklistId"

        />

        <ReportPhotoWorkEvidence
            v-if="modalConfigType === 'evidence_word' &&
            relationAccessSubValidation('sub-checklist-report-photos-work')"
            :enterprise-id="enterpriseId"
            :checklist-id="checklistId"
        />


        <ReportExtractChecklist
            v-if="modalConfigType === 'extract_inspection' &&
           relationAccessSubValidation('sub-checklist-report-extract-by-checklist')"
        />

        <ReportExtractOccurrence
            v-if="modalConfigType === 'extract_occurrence' &&
           relationAccessSubValidation('sub-checklist-report-extract-by-occurrence')"
        />

        <ReportExtractSchedule
            v-if="modalConfigType === 'extract_schedule' &&
           relationAccessSubValidation('sub-checklist-report-extract-by-schedule')"
        />


      </div>
    </b-modal>

    <t-page-general :current-page="currentPage" :user-auth="userAuth">

      <div style="margin: auto" class="mb-3" v-if="!busy">

        <slot name="header"></slot>

        <div v-if="accountModule === 'estate'">

          <div class="report-main-actions">

            <b-button
                @click="openConfigModal('occurrence_estate')"
                size="lg"
                class="report-main-button mt-3"
                variant="outline-primary"
            >
              Relatórios de Apontamentos
            </b-button>


          </div>


        </div>

        <div v-else>

          <div class="report-main-actions">
            <b-button
                v-b-toggle.collapse-evidence
                size="lg"
                class="report-main-button mt-3"
                variant="outline-primary"
            >
              <b-icon-camera class="mr-2"/>
              Memorial Fotográfico
            </b-button>
          </div>

          <b-collapse id="collapse-evidence" v-model="collapseEvidence" class="mt-3">

            <b-card class="report-collapse-card">

              <div class="report-type-header">
                <h5 class="mb-1">Tipo de relatório fotográfico</h5>
                <p class="mb-0">
                  Escolha a origem dos registros para montar o memorial fotográfico.
                </p>
              </div>

              <div class="report-type-switch mb-4">
                <button
                    type="button"
                    class="report-type-card"
                    :disabled="!relationAccessSubValidation('sub-checklist-report-photos-evidence')"
                    @click="openConfigModal('evidence_inspection')"
                >
                  <div class="report-type-card__icon">
                    <i class="lnr-store"></i>
                  </div>

                  <div class="report-type-card__content">
                    <div class="report-type-card__title">Fotográfico por Inspeção</div>
                    <div class="report-type-card__desc">
                      Evidências de uma inspeção específica
                    </div>
                  </div>
                </button>

                <button
                    type="button"
                    class="report-type-card"
                    :disabled="!relationAccessSubValidation('sub-checklist-report-photos-enterprise')"
                    @click="openConfigModal('evidence_enterprise')"
                >
                  <div class="report-type-card__icon">
                    <i class="lnr-apartment"></i>
                  </div>

                  <div class="report-type-card__content">
                    <div class="report-type-card__title">Fotográfico por Empreendimento</div>
                    <div class="report-type-card__desc">
                      Consolida registros do empreendimento
                    </div>
                  </div>
                </button>
              </div>


            </b-card>
          </b-collapse>

          <div class="report-main-actions">
            <b-button
                v-b-toggle.collapse-occurrence
                size="lg"
                class="report-main-button mt-3"
                variant="outline-primary"
            >
              <b-icon-clipboard-check class="mr-2"/>
              Relatórios de Apontamentos
            </b-button>
          </div>

          <b-collapse id="collapse-occurrence"  v-model="collapseOccurrence" class="mt-3">
            <b-card class="report-collapse-card">

              <div class="report-type-header">
                <h5 class="mb-1">Tipo de relatório</h5>
                <p class="mb-0">
                  Escolha se deseja gerar um relatório por inspeção específica ou consolidado por empreendimento.
                </p>
              </div>

              <div class="report-type-switch mb-4">

                <button
                    type="button"
                    class="report-type-card"
                    :disabled="!relationAccessSubValidation('sub-checklist-report-photos-evidence')"
                    @click="openConfigModal('occurrence_inspection')"
                >
                  <div class="report-type-card__icon">
                    <i class="lnr-store"></i>
                  </div>

                  <div class="report-type-card__content">
                    <div class="report-type-card__title">Laudo por Inspeção</div>
                    <div class="report-type-card__desc">
                      Relatório de uma inspeção específica.
                    </div>
                  </div>
                </button>

                <button
                    type="button"
                    class="report-type-card"
                    :disabled="!relationAccessSubValidation('sub-checklist-report-photos-occurrence-by-enterprise')"
                    @click="openConfigModal('occurrence_enterprise')"
                >
                  <div class="report-type-card__icon">
                    <i class="lnr-apartment"></i>
                  </div>

                  <div class="report-type-card__content">
                    <div class="report-type-card__title">Laudo por Empreendimento</div>
                    <div class="report-type-card__desc">
                      Consolida inspeções do empreendimento.
                    </div>
                  </div>
                </button>

                <button
                    type="button"
                    class="report-type-card"
                    :disabled="!relationAccessSubValidation('sub-checklist-report-occurrence-by-period-enterprise')"
                    @click="openConfigModal('occurrence_by_period_enterprise')"
                >
                  <div class="report-type-card__icon">
                    <i class="lnr-pie-chart"></i>
                  </div>

                  <div class="report-type-card__content">
                    <div class="report-type-card__title">Evolução por Período</div>
                    <div class="report-type-card__desc">
                      Gráficos e dados ao longo do tempo
                    </div>
                  </div>
                </button>

                <button
                    type="button"
                    class="report-type-card"
                    :disabled="!relationAccessSubValidation('sub-checklist-report-occurrence-quality-enterprise')"
                    @click="openConfigModal('occurrence_kpi')"
                >
                  <div class="report-type-card__icon">
                    <i class="lnr-chart-bars"></i>
                  </div>

                  <div class="report-type-card__content">
                    <div class="report-type-card__title">Indicadores de Qualidade</div>
                    <div class="report-type-card__desc">
                      Métricas e Desempenho das Inspeções
                    </div>
                  </div>
                </button>


                <button
                    type="button"
                    class="report-type-card"
                    @click="openConfigModal('occurrence_ranking')"
                >
                  <div class="report-type-card__icon">
                    <b-icon-bar-chart-line/>
                  </div>

                  <div class="report-type-card__content">
                    <div class="report-type-card__title">Rankings de Apontamentos</div>
                    <div class="report-type-card__desc">
                      Visualize inspeções e apontamentos diretamente no mapa.
                    </div>
                  </div>
                </button>

                <button
                    type="button"
                    class="report-type-card"
                    @click="openConfigModal('checklist_management')"
                >
                  <div class="report-type-card__icon">
                    <b-icon-diagram-3 />
                  </div>

                  <div class="report-type-card__content">
                    <div class="report-type-card__title">Resumo por Empreendimento</div>
                    <div class="report-type-card__desc">
                      Visualize o resumo de apontamentos registrados em cada empreendimento.
                    </div>
                  </div>
                </button>


              </div>

            </b-card>
          </b-collapse>



          <div class="report-main-actions">
            <b-button
                v-b-toggle.collapse-management
                size="lg"
                class="report-main-button mt-3"
                variant="outline-primary"
            >
              <b-icon-bar-chart-line class="mr-2"/>
              Indicadores Gerenciais
            </b-button>
          </div>


          <b-collapse id="collapse-management" class="mt-3">
            <b-card class="report-collapse-card">

              <div class="report-type-header">
                <h5 class="mb-1">Análises gerenciais</h5>
                <p class="mb-0">
                  Visualize indicadores gerenciais das inspeções e da equipe técnica.
                </p>
              </div>

              <div class="report-type-switch mb-4">

                <button
                    type="button"
                    class="report-type-card"
                    :disabled="!relationAccessSubValidation('example1')"
                    @click="openConfigModal('management_by_enterprise')"
                >
                  <div class="report-type-card__icon">
                    <i class="lnr-location"></i>
                  </div>

                  <div class="report-type-card__content">
                    <div class="report-type-card__title">Cobertura por Unidade</div>
                    <div class="report-type-card__desc">
                      Resumo com indicadores de frequência e cobertura das inspeções
                    </div>
                  </div>
                </button>

                <button
                    type="button"
                    class="report-type-card"
                    :disabled="!relationAccessSubValidation('example2')"
                    @click="openConfigModal('management_by_inspector')"
                >
                  <div class="report-type-card__icon">
                    <i class="lnr-users"></i>
                  </div>

                  <div class="report-type-card__content">
                    <div class="report-type-card__title">Produtividade por Inspetor</div>
                    <div class="report-type-card__desc">
                      Analisa o volume de inspeções e apontamentos realizados por cada inspetor.
                    </div>
                  </div>
                </button>


                <button
                    type="button"
                    class="report-type-card"
                    :disabled="!relationAccessSubValidation('example2')"
                    @click="openConfigModal('management_by_time')"
                >
                  <div class="report-type-card__icon">
                    <i class="lnr-clock"></i>
                  </div>

                  <div class="report-type-card__content">
                    <div class="report-type-card__title">Tempo Médio de Atendimento</div>
                    <div class="report-type-card__desc">
                      Avalia o tempo médio entre a abertura e a resolução das ocorrências.
                    </div>
                  </div>
                </button>


                <button
                    type="button"
                    class="report-type-card"
                    :disabled="!relationAccessSubValidation('example2')"
                    @click="openConfigModal('management_by_inspector')"
                >
                  <div class="report-type-card__icon">
                    <i class="lnr-sync"></i>
                  </div>

                  <div class="report-type-card__content">
                    <div class="report-type-card__title">Reincidência de Ocorrências</div>
                    <div class="report-type-card__desc">
                      Identifica problemas recorrentes nas unidades e ambientes inspecionados.
                    </div>
                  </div>
                </button>


              </div>

            </b-card>
          </b-collapse>

        </div>

        <slot name="after-report-advanced"></slot>




        <div class="report-main-actions">

          <b-button v-b-toggle.collapse-xlsx size="lg"
                    class="report-main-button mt-3" variant="outline-primary">

            <b-icon-list-task/>
            Extratos para Excel
          </b-button>
        </div>


        <b-collapse id="collapse-xlsx" class="mt-3">
          <b-card class="report-collapse-card">

            <div class="report-type-header">
              <h5 class="mb-1">Tipo de extrato</h5>
              <p class="mb-0">
                Escolha a planilha que deseja exportar.
              </p>
            </div>

            <div class="report-type-switch mb-4">

              <button
                  type="button"
                  class="report-type-card"
                  :disabled="!relationAccessSubValidation('sub-checklist-report-extract-by-checklist')"
                  @click="openConfigModal('extract_inspection')">
                <div class="report-type-card__icon">
                  <b-icon-clipboard-data/>
                </div>

                <div class="report-type-card__content">
                  <div class="report-type-card__title">Extrato de Inspeções</div>
                  <div class="report-type-card__desc">
                    Lista os dados das inspeções realizadas.
                  </div>
                </div>
              </button>

              <button
                  type="button"
                  class="report-type-card"
                  :disabled="!relationAccessSubValidation('sub-checklist-report-extract-by-occurrence')"
                  @click="openConfigModal('extract_occurrence')"
              >
                <div class="report-type-card__icon">
                  <b-icon-card-checklist/>
                </div>

                <div class="report-type-card__content">
                  <div class="report-type-card__title">Extrato de Apontamentos</div>
                  <div class="report-type-card__desc">
                    Exporta os apontamentos registrados.
                  </div>
                </div>
              </button>

              <button
                  type="button"
                  class="report-type-card"
                  :disabled="!relationAccessSubValidation('sub-checklist-report-extract-by-schedule')"
                  @click="openConfigModal('extract_schedule')"
              >
                <div class="report-type-card__icon">
                  <b-icon-calendar3/>
                </div>

                <div class="report-type-card__content">
                  <div class="report-type-card__title">Extrato de Agenda</div>
                  <div class="report-type-card__desc">
                    Exporta compromissos e programações.
                  </div>
                </div>
              </button>


            </div>

          </b-card>
        </b-collapse>


        <div class="report-main-actions">

          <b-button :to="{path:'/general/my-report'}" size="lg"
                    class="report-main-button mt-3" variant="outline-primary">
            <b-icon-clock-history/>
            Histórico de Relatórios
          </b-button>

        </div>


      </div>


      <slot name="footer"></slot>


      <div class="d-flex align-content-center justify-content-center"></div>

    </t-page-general>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import ReportPhotoChecklistOccurrence from "@/views/modules/checklist/Report/ReportPhotoChecklistOccurrence";
import ReportPhotoEnterpriseOccurrence from "@/views/modules/checklist/Report/ReportPhotoEnterpriseOccurrence.vue";
import ReportPhotoChecklistEvidence from "@/views/modules/checklist/Report/ReportPhotoChecklistEvidence";
import ReportPhotoEnterpriseEvidence from "@/views/modules/checklist/Report/ReportPhotoEnterpriseEvidence";
import ReportPhotoWorkEvidence from "@/views/modules/checklist/Report/ReportPhotoWorkEvidence";
import ReportExtractChecklist from "@/views/modules/checklist/Report/ReportExtractChecklist";
import ReportExtractOccurrence from "@/views/modules/checklist/Report/ReportExtractOccurrence";
import ReportExtractSchedule from "@/views/modules/checklist/Report/ReportExtractSchedule";
import ReportChecklistManagement from "@/views/modules/checklist/Report/ReportChecklistManagement.vue";
import ReportOccurrenceQuality from "@/views/modules/checklist/Report/ReportOccurrenceQuality.vue";
import ReportPhotoChecklistEstate from "@/views/modules/checklist/Report/ReportPhotoChecklistEstate";
import ui from "@/assets/scripts/ui";
import SurveyType from "@/model/types/modules/checklist/SurveyType";

export default {
  mixins: [pageDefaultMixin],
  components: {
    ReportPhotoChecklistOccurrence,
    ReportPhotoOccurrenceByEnterprise: ReportPhotoEnterpriseOccurrence,
    ReportPhotoChecklistEvidence,
    ReportPhotoEnterpriseEvidence,
    ReportPhotoWorkEvidence,
    ReportExtractChecklist,
    ReportExtractOccurrence,
    ReportExtractSchedule,
    ReportPhotoChecklistEstate,
    ReportChecklistManagement,
    ReportOccurrenceQuality
  },
  name: 'ChecklistReport',
  data() {
    return {
      path: "checklist/report",
      reportOccurrenceType: 0,
      reportEvidenceType: 0,
      accountModule: "",
      enterpriseId: 0,
      checklistId: 0,
      typeChecklistId: 0,
      businessTypeSurvey: 0,
      busy: false,
      modalConfigType: null,
      collapseEvidence: false,
      collapseOccurrence: false,
    }
  },
  methods: {

    mountedPrepare() {
      this.busy = true
      this.accountModule = ui.getAccountModule()
    },
    async mountedContinued() {
      if (this.$route.query.enterpriseId) {
        this.enterpriseId = parseInt(this.$route.query.enterpriseId);
      }
      if (this.$route.query.checklistId) {
        this.checklistId = parseInt(this.$route.query.checklistId);
      }
      if (this.$route.query.typeChecklistId) {
        this.typeChecklistId = parseInt(this.$route.query.typeChecklistId);
      }
      if (this.$route.query.businessTypeSurvey) {
        this.businessTypeSurvey = parseInt(this.$route.query.businessTypeSurvey);
      }

      if(this.businessTypeSurvey === SurveyType.type.EVIDENCE){
        this.collapseEvidence = true
      }else if(this.businessTypeSurvey === SurveyType.type.OCCURRENCE){
        this.collapseOccurrence = true
      }else if(this.businessTypeSurvey === SurveyType.type.ESTATE && this.checklistId > 0){
        this.openConfigModal('occurrence_estate')
      }


      this.busy = false
    },

    openConfigModal(type) {
      this.modalConfigType = type
      this.$bvModal.show('report-config-modal')
    },


  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedDefault()

    await this.mountedContinued()

  },
  computed: {

    reportConfigTitle() {
      const titles = {
        occurrence_inspection: 'Configurar relatório por inspeção',
        occurrence_enterprise: 'Configurar relatório por empreendimento',
        occurrence_by_period_enterprise: 'Evolução por período',
        occurrence_kpi: 'Indicadores de qualidade',
        occurrence_ranking: 'Ranking de apontamentos',
        management_by_enterprise: 'Cobertura por Unidades',
        extract_inspection: 'Extrato de inspeções',
        extract_occurrence: 'Extrato de apontamentos',
        extract_schedule: 'Extrato de agenda',
      }

      return titles[this.modalConfigType] || 'Configurar relatório'
    }
  }

}
</script>
<style>

</style>